import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { HotelContext } from "../../context/HotelContext";
import { translate } from "../../utils/Translation";
import CalendarIcon from "../../img/v2/calendar-icon.svg";
import "./MonthYearNavigator.css";

const YearNavigator = ({ year, onChange, yearsBack = 10 }) => {
  const { lang } = useContext(HotelContext);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const now = useMemo(() => new Date(), []);

  const years = useMemo(() => {
    const baseYear = now.getFullYear();
    return Array.from({ length: yearsBack }, (_, i) => {
      const y = baseYear - i;
      return { value: y, label: y.toString() };
    });
  }, [now, yearsBack]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const shiftYear = (delta) => {
    const nextYear = year + delta;
    onChange({ year: nextYear });
  };

  const handleYearSelect = (e) => {
    const nextYear = parseInt(e.target.value, 10);
    onChange({ year: nextYear });
    setIsOpen(false);
  };

  return (
    <div className="month-year-nav" aria-label={translate("v2_year_nav_aria", lang)}>
      <button
        type="button"
        className="month-year-nav__arrow"
        onClick={() => shiftYear(-1)}
        aria-label={translate("v2_year_prev", lang)}
      >
        ◀
      </button>

      <div className="month-year-selector" ref={dropdownRef}>
        <button
          className="month-year-selector__button"
          onClick={() => setIsOpen(!isOpen)}
          type="button"
          aria-haspopup="dialog"
          aria-expanded={isOpen}
          style={{ minWidth: "140px" }}
        >
          <img src={CalendarIcon} alt="" className="month-year-selector__icon" />
          <span className="month-year-selector__text">{translate("v2_graph_year_label", lang, { year })}</span>
        </button>

        {isOpen && (
          <div className="month-year-selector__dropdown">
            <div className="month-year-selector__dropdown-row">
              <div className="month-year-selector__dropdown-section">
                <label className="month-year-selector__label">{translate("v2_year_label", lang)}</label>
                <select className="month-year-selector__select" value={year} onChange={handleYearSelect}>
                  {years.map((y) => (
                    <option key={y.value} value={y.value}>
                      {y.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        )}
      </div>

      <button
        type="button"
        className="month-year-nav__arrow"
        onClick={() => shiftYear(1)}
        aria-label={translate("v2_year_next", lang)}
      >
        ▶
      </button>
    </div>
  );
};

export default YearNavigator;
